/* jc-faq-more.js — JC-EVO 09/25/2026: FAQ design A ("Apple Support list"), Eric's pick (mockups gutters-fix/mock-faq/).
 * Loaded (defer) by sections/custom-faq.liquid only for the custom_class "faqs" section with 10+ questions.
 * Shows the first 6 questions and a real <button> "Show all N questions" (aria-expanded + aria-controls). The other
 * rows stay in the DOM with hidden="until-found", so find-in-page and URL fragments still reach them: the browser fires
 * `beforematch` and the whole list opens. Browsers without hidden=until-found keep every question visible, so nothing
 * is ever unfindable. Each question stays a native <details>/<summary>. Styles: assets/custom-theme.css, block
 * "JC-EVO 09/25/2026: FAQ A + shipping C". Idempotent (data-jc-more).
 */
(function () {
  'use strict';
  var SHOW = 6, MIN = 10, uid = 0;
  var canFind = 'onbeforematch' in document.documentElement;

  function init(sec) {
    if (!canFind || !sec || sec.hasAttribute('data-jc-more')) return;
    var list = sec.querySelector('.faq__list');
    if (!list) return;
    var items = Array.prototype.filter.call(list.children, function (e) { return e.matches('details.faq__item'); });
    if (items.length < MIN) return;
    sec.setAttribute('data-jc-more', '');
    if (!list.id) list.id = 'jc-faq-list-' + (++uid);
    var rest = items.slice(SHOW);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'jc-faq-more';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', list.id);
    btn.textContent = 'Show all ' + items.length + ' questions';

    function expand(moveFocus) {
      if (!btn.isConnected) return;
      rest.forEach(function (d) { d.removeAttribute('hidden'); });
      btn.setAttribute('aria-expanded', 'true');
      btn.remove();                       // nothing left to show; focus goes to the first newly shown question
      if (moveFocus) { var s = rest[0].querySelector('summary'); if (s) s.focus(); }
    }
    rest.forEach(function (d) {
      d.setAttribute('hidden', 'until-found');
      d.addEventListener('beforematch', function () { expand(false); });
    });
    btn.addEventListener('click', function () { expand(true); });
    list.parentNode.insertBefore(btn, list.nextSibling);

    // a fragment pointing inside a hidden row (browsers reveal until-found on fragment navigation too; this also opens it)
    function fromHash() {
      var id; try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
      var t = id && document.getElementById(id);
      var d = t && t.closest && t.closest('details.faq__item');
      if (!d || rest.indexOf(d) < 0) return;
      expand(false);
      d.open = true;
    }
    fromHash();
    window.addEventListener('hashchange', fromHash);
  }

  function run(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('section.custom-faq.faqs'), init);
  }
  run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
